import { estados, Estados, STATUS, ValidacaoErro } from "@/types/api"
import {
  AutenticacaoResposta,
  Credenciais,
} from "@/repositorios/autenticacao/autenticacao.modelo"
import AutenticacaoRepositorio from "@/repositorios/autenticacao/autenticacao.repositorio"
import { defineStore } from "pinia"
import SessaoServico from "@/servicos/sessao.service"
import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
import { usarLimpadorDeStore } from "@/composable/UsarLimpadorDeStore/usarLimpadorDeStore"
import { concluirSessaoAutenticada } from "@/servicos/autenticacao.service"
import { encerrarSessaoAutenticada } from "@/servicos/logout.service"

export interface AutenticacaoSucesso {
  status: "sucesso"
}
export interface AutenticacaoErro {
  status: "erro"
  codigo?: number | "cancelado"
}
type AutenticacaoStatus = AutenticacaoSucesso | AutenticacaoErro

interface PossuiCodigo {
  codigo?: number
}

function temCodigo(valor: unknown): valor is PossuiCodigo {
  return typeof valor === "object" && valor !== null && "codigo" in valor
}
export interface SessaoUsuario {
  tokenRenovacao: string | null
  token: string | null
  tipo: string | null
  autenticado: boolean
  profissionalDoUsuario: string | null
}

export interface AutenticacaoEstado {
  autenticadores: SessaoUsuario
  erros: ValidacaoErro | null
  estado: Estados
}

const { escritor } = usarEscritorDeDados()
const autenticacaoRep = new AutenticacaoRepositorio()
const escreverLogin = escritor<AutenticacaoResposta, Credenciais>(
  autenticacaoRep.autenticar,
  []
)
export const AutenticacaoStore = defineStore("autenticacao", {
  state: (): AutenticacaoEstado => ({
    autenticadores: SessaoServico,
    erros: null,
    estado: 0,
  }),
  actions: {
    async logar(email: string, senha: string): Promise<AutenticacaoStatus> {
      this.estado = estados.PEDENTE

      const dados: Credenciais = { username: email, password: senha }
      escreverLogin.mudarArgumentos([dados])
      await escreverLogin.executar()

      if (escreverLogin.resultado.status === "sucesso") {
        if (escreverLogin.resultado.dados.possui_timesheet === false) {
          this.estado = estados.ERRO
          SessaoServico.limparInformacoesDaSessao()
          return {
            status: "erro",
            codigo: STATUS.naoPermitido,
          }
        }

        try {
          await concluirSessaoAutenticada(
            escreverLogin.resultado.dados.access_token,
            escreverLogin.resultado.dados.refresh_token
          )
        } catch (erro) {
          this.estado = estados.ERRO
          SessaoServico.limparInformacoesDaSessao()
          const codigoErro = temCodigo(erro) ? erro.codigo : undefined
          if (codigoErro === 403) {
            return {
              status: "erro",
              codigo: STATUS.naoPermitido,
            }
          }
          return {
            status: "erro",
          }
        }

        this.estado = estados.SUCESSO
        return {
          status: "sucesso",
        }
      }

      this.estado = estados.ERRO
      this.autenticadores.token = null
      this.autenticadores.tokenRenovacao = null
      this.autenticadores.tipo = null
      return {
        status: "erro",
        codigo:
          escreverLogin.resultado.status === "erro"
            ? escreverLogin.resultado.codigo
            : undefined,
      }
    },
    deslogar(): void {
      const limpadorDeStores = usarLimpadorDeStore()
      encerrarSessaoAutenticada(() => {
        this.erros = null
        this.estado = 0
        limpadorDeStores.todasAsStores()
      })
    },
  },
})
